import { render, staticRenderFns } from "./ShopClassList.vue?vue&type=template&id=87903dc8&"
import script from "./ShopClassList.vue?vue&type=script&lang=js&"
export * from "./ShopClassList.vue?vue&type=script&lang=js&"
import style0 from "./ShopClassList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports